<template>
  <md-dialog :md-active.sync="show" :md-click-outside-to-close="false" :md-close-on-esc="false">
    <span v-if="!voi_data">
      <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
    </span>
    <md-dialog-content>
      <voi-summary class="voi-summary" :voi_data="voi_data"/>
    </md-dialog-content>
    <md-dialog-actions
        class="action-buttons"
      >
        <md-progress-spinner
          :md-diameter="30"
          :md-stroke="3"
          md-mode="indeterminate"
          v-if="isUpdating"
        ></md-progress-spinner>
        <md-button
          class="md-danger"
          @click="$emit('decline')"
          :disabled="isUpdating"
          >Decline</md-button
        >
        <md-button
          class="submit-btn"
          @click="$emit('proceed')"
          :disabled="isUpdating"
          >Confirm</md-button
        >
      </md-dialog-actions>
  </md-dialog>
</template>

<script>
import VoiSummary from './VoiSummary.vue';

export default {
  components: {
    VoiSummary,
  },
  props: {
    isUpdating: {
      type: Boolean,
      default: false,
    },
    voi_data: {
      default: {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/theme.scss";
  .voi-summary {
    display: block;
  }

  .submit-btn {
    background-color: $ausloans-green-dark !important;
  }

  .md-dialog-content {
    margin-bottom: 30px;
  }

  .md-progress-spinner {
    padding: 17px;
    margin-left: 5vw;
  }
  .action-buttons {
    bottom: 52px;
    margin-left: 10%;
    margin-bottom: -50px;
  }

</style>
